import http from '@/libs/http'
const baseUrl = process.env.VUE_APP_MICROSERVICE_API_SAP_SYNC

export default class PagosRecibidosService {
  paginate (params) {
    return http.get(`${baseUrl}/pagos/obtener-pagos`, {
      params,
      headers: {
        loading: true
      }
    })
  }

  hitorial (params) {
    return http.get(`${baseUrl}/pagos/obtener-pagos/history`, {
      params,
      headers: {
        loading: true
      }
    })
  }
}
